const checkLicense = (license) => {
  if (!license) return false;
  return license.split(',').every(function (val) {
    return /^[a-zA-Z0-9]{32}$/.test(val);
  })
}

const checkNull = (rule, value, callback) => {
  !value || value === '' ? callback([new Error('必填不能为空')]) : callback();
}

const checkLicenseNull = (rule, value, callback) => {
  checkLicense(value) ? callback() : callback("license格式错误，多个license请用英文逗号隔开！");
}
const checkLen = (rule, value, callback) => {
  if (!value || value.length === 0 || value === "") {
    callback([new Error('此选项必填，不能为空')]);
  } else {
    callback();
  }
}
export default {
  checkNull,
  checkLicense,
  checkLicenseNull,
  checkLen,
}


// WEBPACK FOOTER //
// ./src/components/util/appApply/validate.js